import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-overlay-panel',
  template: `
    <div class="overlay-panel" [style.height]="loaderHeight + 'px'">
      <ng-container *ngIf="showLoader">
        <div class="overlay-panel__loader"></div>
      </ng-container>
    </div>
  `,
  styleUrls: ['./overlay-panel.component.scss']
})
export class OverlayPanelComponent {
  @Input() public loaderHeight: number = 2;

  @Input() public showLoader: boolean = true;
}
